import { defineMessages } from 'react-intl';

export const messages: {
	searchDialogAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendationsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendedHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchResultsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchDialogAriaLabel: {
		id: 'search_dialog_aria_label',
		defaultMessage: 'Search Dialog',
		description:
			'Accessible aria-label for the Quick Find search dialog container element, used by screen readers to identify the search dialog region.',
	},
	recentsHeading: {
		id: 'search_dialog_recents_heading',
		defaultMessage: 'Recent',
		description:
			'Section heading displayed in the Quick Find dialog above the list of recently viewed items when no search query has been typed.',
	},
	recommendationsHeading: {
		id: 'search_dialog_recommendations_heading',
		defaultMessage: 'Recommendations',
		description:
			'Section heading displayed in the Quick Find dialog above AI-generated or personalized content recommendations when no search query has been typed.',
	},
	recommendedHeading: {
		id: 'search_dialog_recommended_heading',
		defaultMessage: 'Recommended',
		description:
			'Section heading displayed in the Quick Find dialog above recommended documents when no search query has been typed.',
	},
	searchResultsHeading: {
		id: 'recents_heading',
		defaultMessage: 'Search Results',
		description:
			"Section heading displayed in the Quick Find dialog above the list of search results returned for the user's query.",
	},
});
